"use client";

import { usePathname } from "next/navigation";
import { Footer } from "../ui/Footer";

const HIDDEN_PREFIXES = [
  "/connect-admin",
  "/lessons/call",
  "/lessons/classroom",
  "/realtime-feedback/demo",
];

export function ConditionalFooter() {
  const pathname = usePathname() ?? "";

  if (HIDDEN_PREFIXES.some(prefix => pathname.startsWith(prefix))) {
    return null;
  }

  return <Footer />;
}
